// extracted by mini-css-extract-plugin
export default {"header":"Header_header__23ITg","link":"Header_link__Or2d2","logo":"Header_logo__D9fLO"};